export default {
  boolean: "boolean",
  rating: "rating",
};
